import { isEmpty } from "lodash";

export const getPortMediaType = ( ({
  selectedRows
}) => {
  let result = {
    isCopper: false,
    isFiber: false,
    copperPorts: [],
    fibberPorts: [],
  }

  if(!selectedRows) return result;

  const selectedPorts = selectedRows.map(row => row.original);

  selectedPorts.forEach(port => {
    const mediaType = +(port?.switchPort?.portStaMediaType);

    if(mediaType === 1) {
      result.isCopper = true;
      result.copperPorts.push(port);
    }else if(mediaType === 2){
      result.isFiber = true;
      result.fibberPorts.push(port);
    }
  });

  return result;
});

export const getPortTagsRequestParams = ({ auth, method = "read" }) => {
  const isStandaloneMode = !auth.orgs || Object.keys(auth.orgs).length === 0;
  const apiBaseUrl = isStandaloneMode ? `/orgs/:orgId` : `/ents/:entId/orgs/:orgId`;
  const apiPaths = `${apiBaseUrl}/sites/:siteId/settings/tags/portTags.${method}`;

  const restfulParamsConfig = {
    standalone: {
      orgId: auth.realm?.id,
      siteId: auth.sites?.id,
    },
    nonStandalone: {
      entId: auth.realm?.id,
      orgId: auth.realm?.id,
      siteId: auth.sites?.id,
    },
  };

  const restfulParams = isStandaloneMode ? restfulParamsConfig["standalone"] : restfulParamsConfig["nonStandalone"];

  return {
    apiPaths,
    restfulParams
  };
}

export const getPortTagsCreatePayload = ({ tags }) => {
  return {
    data: {
      tagName: tags?.tagName ? tags.tagName : null
    }
  }
}

export const initChips = ({ chips, tags }) => {
  // 1. Use chip id to change the format to { tagName: xxx, tagId: xxx }.
  // 2. Remove saved chips which no longer exist in tags.
  const comparisonEnum = tags.reduce((acc, tag) => {
    return {
      ...acc,
      [tag.tagId]: tag
    }
  }, {});

  const newChips = chips.map(chipId => {
    const matchedChip = comparisonEnum[chipId];
    return isEmpty(matchedChip) ? null : matchedChip;
  }).filter(chip => !!chip)

  return newChips
}